import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["data", "columns", "checkboxCellStyle", "keyField", "style", "onRowClick", "onPageClick", "rowHeight", "tableHeaderHeight", "pageSize", "rowStyle", "className", "loading", "EmptyPlaceholder", "getTrProps"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import 'react-table/react-table.css';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _noop from 'lodash/noop';
import _last from 'lodash/last';
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import colors from 'tstyles/variables.scss';
import checkboxHOC from './checkBoxHOC';
import FixedColumnTable from './FixedColumnTable';

// Helpers
import { makeGetTrProps } from './helpers/rowHelpers';
var CheckBoxTable = checkboxHOC(FixedColumnTable);
var ALICE_BLUE = colors.aliceBlue;
var WHITE = colors.white;
var CheckboxTableComponent = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CheckboxTableComponent, _React$PureComponent);
  var _super = _createSuper(CheckboxTableComponent);
  function CheckboxTableComponent(props) {
    var _this;
    _classCallCheck(this, CheckboxTableComponent);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "getRowProps", function (state, rowInfo) {
      var _last2;
      var _this$props = _this.props,
        onRowClick = _this$props.onRowClick,
        rowHeight = _this$props.rowHeight,
        rowStyle = _this$props.rowStyle,
        showRowHoverColor = _this$props.showRowHoverColor; // eslint-disable-line
      var rowId = _get(rowInfo, 'original.id', '');
      var avoidSelectedBgColor = _get(rowInfo, 'original.avoidSelectedBgColor', false);
      for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        rest[_key - 2] = arguments[_key];
      }
      var rowPropStyle = ((_last2 = _last(rest)) === null || _last2 === void 0 ? void 0 : _last2.style) || {};
      var rowBackgroundColor = rowPropStyle === null || rowPropStyle === void 0 ? void 0 : rowPropStyle.backgroundColor;
      var backgroundColor = _this.isSelected(rowId) && !avoidSelectedBgColor ? ALICE_BLUE : rowBackgroundColor || WHITE;
      if (rowInfo && rowInfo.row) {
        return {
          onClick: function onClick() {
            onRowClick(rowInfo);
          },
          style: _objectSpread({
            height: rowHeight,
            backgroundColor: backgroundColor
          }, rowStyle),
          className: showRowHoverColor && 'rowHoverColor'
        };
      }
      return {
        style: _objectSpread({
          height: rowHeight
        }, rowStyle)
      };
    });
    _defineProperty(_assertThisInitialized(_this), "toggleSelection", function (key, shift, row) {
      // eslint-disable-line
      var onSelect = _this.props.onSelect;
      var selectionFromProps = _this.state.selection;
      // start off with the existing state
      var selection = _toConsumableArray(selectionFromProps);
      var keyIndex = selection.indexOf(key);
      // check to see if the key exists
      if (keyIndex >= 0) {
        // it does exist so we will remove it using destructing
        selection = [].concat(_toConsumableArray(selection.slice(0, keyIndex)), _toConsumableArray(selection.slice(keyIndex + 1)));
      } else {
        // it does not exist so add it
        selection.push(key);
      }
      // update the state
      _this.setState({
        selection: selection
      }, function () {
        onSelect(selection, key);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "toggleAll", function () {
      var onSelect = _this.props.onSelect;
      var selectAllFromProps = _this.state.selectAll;
      var selectAll = !selectAllFromProps;
      var selection = [];
      if (selectAll) {
        // we need to get at the internals of ReactTable
        var wrappedInstance = _this.checkboxTable.getWrappedInstance();
        var getResolvedState = _get(wrappedInstance, 'reactTableFixedColumns.reactTable.current.getResolvedState', _noop);
        // the 'sortedData' property contains the currently accessible records based on the filter and sort
        var _ref = getResolvedState() || EMPTY_OBJECT,
          sortedData = _ref.sortedData;
        // we just push all the IDs onto the selection array
        sortedData.forEach(function (item) {
          var rowId = _get(item, '_original.id');
          if (!_this.isDisabled(rowId)) selection.push(rowId);else if (_this.isSelected(rowId)) selection.push(rowId);
        });
      }
      _this.setState({
        selectAll: selectAll,
        selection: selection
      }, function () {
        onSelect(selection, null);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "isSelected", function (key) {
      var selection = _this.state.selection;
      return selection.includes(key);
    });
    _defineProperty(_assertThisInitialized(_this), "isDisabled", function (key) {
      var disabled = _this.state.disabled;
      return disabled.includes(key);
    });
    _this.state = {
      selection: props.selection || EMPTY_ARRAY,
      selectAll: props.selectAll,
      indeterminate: props.indeterminate,
      disabled: props.disabled
    };
    _this.getTrProps = makeGetTrProps(props.getTrProps, _this.getRowProps);
    return _this;
  }
  _createClass(CheckboxTableComponent, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var newState = {};
      var _this$props2 = this.props,
        currentSelection = _this$props2.selection,
        currentSelectAll = _this$props2.selectAll,
        currentIndeterminate = _this$props2.indeterminate,
        currentDisabled = _this$props2.disabled;
      var prevSelection = prevProps.selection,
        prevSelectAll = prevProps.selectAll,
        prevIndeterminate = prevProps.indeterminate,
        prevDisabled = prevProps.disabled;
      if (Array.isArray(currentSelection)) {
        newState.selection = currentSelection;
      }
      if (currentSelectAll !== prevSelectAll) {
        newState.selectAll = currentSelectAll;
      }
      if (currentIndeterminate !== prevIndeterminate) {
        newState.indeterminate = currentIndeterminate;
      }
      if (currentDisabled !== prevDisabled) {
        newState.disabled = currentDisabled;
      }
      this.setState(newState); // eslint-disable-line
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var toggleSelection = this.toggleSelection,
        toggleAll = this.toggleAll,
        isSelected = this.isSelected,
        isDisabled = this.isDisabled; // eslint-disable-line
      var _this$state = this.state,
        selectAll = _this$state.selectAll,
        indeterminate = _this$state.indeterminate;
      var _this$props3 = this.props,
        data = _this$props3.data,
        columns = _this$props3.columns,
        checkboxCellStyle = _this$props3.checkboxCellStyle,
        keyField = _this$props3.keyField,
        style = _this$props3.style,
        onRowClick = _this$props3.onRowClick,
        onPageClick = _this$props3.onPageClick,
        rowHeight = _this$props3.rowHeight,
        tableHeaderHeight = _this$props3.tableHeaderHeight,
        pageSize = _this$props3.pageSize,
        rowStyle = _this$props3.rowStyle,
        className = _this$props3.className,
        loading = _this$props3.loading,
        EmptyPlaceholder = _this$props3.EmptyPlaceholder,
        getTrProps = _this$props3.getTrProps,
        rest = _objectWithoutProperties(_this$props3, _excluded);
      var checkboxProps = {
        selectAll: selectAll,
        isSelected: isSelected,
        toggleSelection: toggleSelection,
        toggleAll: toggleAll,
        selectType: 'checkbox',
        indeterminate: indeterminate,
        isDisabled: isDisabled
      };
      return /*#__PURE__*/React.createElement(CheckBoxTable, _extends({
        ref: function ref(r) {
          _this2.checkboxTable = r;
        } // Do not change the ref name
        ,
        data: data,
        columns: columns,
        checkboxCellStyle: checkboxCellStyle,
        defaultPageSize: 10,
        keyField: keyField,
        style: style,
        onRowClick: onRowClick,
        onPageClick: onPageClick,
        className: className,
        rowHeight: rowHeight,
        rowStyle: rowStyle,
        getTrProps: this.getTrProps,
        tableHeaderHeight: tableHeaderHeight,
        isChecked: this.isSelected,
        pageSize: pageSize,
        loading: loading,
        EmptyPlaceholder: EmptyPlaceholder,
        showRowHoverColor: true
      }, rest, checkboxProps));
    }
  }]);
  return CheckboxTableComponent;
}(React.PureComponent);
CheckboxTableComponent.propTypes = {
  onSelect: PropTypes.func,
  showRowHoverColor: PropTypes.bool,
  getTrProps: PropTypes.func,
  noHeadSelector: PropTypes.bool,
  indeterminate: PropTypes.bool,
  selectAll: PropTypes.bool,
  selection: PropTypes.array,
  disabled: PropTypes.array
};
CheckboxTableComponent.defaultProps = {
  onSelect: _noop,
  showRowHoverColor: true,
  getTrProps: _noop,
  noHeadSelector: false,
  indeterminate: false,
  selectAll: false,
  selection: undefined,
  disabled: EMPTY_ARRAY
};
export default CheckboxTableComponent;